export type ScreenPermission = 'granted' | 'prompt' | 'denied' | 'unknown'

export type Capabilities = {
	/** `window.getScreenDetails` exists (Chrome, Edge). */
	windowManagement: boolean
	/** `screen.isExtended`: `undefined` where the browser cannot tell. */
	extended: boolean | undefined
	permission: ScreenPermission
}

/**
 * What Present does:
 *
 * - `place`: open the presentation window on the projector screen
 *   (Chrome/Edge, extended, permission granted);
 * - `ask`: first ask for the screen permission - the prompt needs this click;
 * - `manual`: open it where the browser likes; the trainer drags it to the
 *   projector (Safari, Firefox, or the permission was denied);
 * - `single`: one screen only - full screen right here, no second window.
 */
export type PresentPath = 'place' | 'ask' | 'manual' | 'single'

export const presentPath = ({
	windowManagement,
	extended,
	permission,
}: Capabilities): PresentPath => {
	if (!windowManagement) {
		return 'manual'
	}
	if (extended === false) {
		return 'single'
	}
	switch (permission) {
		case 'granted':
			return 'place'
		case 'denied':
			return 'manual'
		case 'prompt':
		case 'unknown':
			return 'ask'
	}
}
